<template>
	<span class="category-item-sibling-usp vat small text-uppercase">
		<template v-if="siblings.length > 0">
			<a v-if="variationLink !== '' " :href="variationLink">
				{{ $translate("Eros::Template.categoryItemSiblingUSP") }}
			</a>
			<div v-else>
				{{ $translate("Eros::Template.categoryItemSiblingUSP") }}
			</div>
		</template>
		<template v-else-if="currentLanguage === 'de'">
			<a data-toggle="modal" href="#shippingscosts" :title="$translate('Ceres::Template.itemShippingCosts')">
				{{ $translate("Eros::Template.itemLegalTextAlternative") }}
			</a>
		</template>
		<template v-else>
			{{ $translate("Eros::Template.itemLegalTextAlternative") }}
		</template>
	</span>
</template>

<script>
import { mapState } from "vuex";

export default {
	props: {
		itemId: {
			type: Number,
			required: true
		},
		variationId: {
			type: Number,
			required: true
		},
		variationLink: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			currentLanguage: App.language || "de"
		};
	},

	computed: {
		currentVariation() {
			if (this.itemId in this.categoryItemSiblings) {
				let currentVariation = this.categoryItemSiblings[this.itemId].filter((variation) => {
					return variation.variationId === this.variationId;
				});

				if (currentVariation.length === 1) return currentVariation[0];
			}
			return {};
		},

		hasCurrentVariation() {
			return Object.keys(this.currentVariation).length > 0;
		},

		siblings() {
			if (this.itemId in this.categoryItemSiblings) {
				let siblings = this.categoryItemSiblings[this.itemId].filter((variation) => {
					return variation.variationId !== this.variationId;
				});

				if (siblings.length <= 1) return siblings;

				return siblings.slice(0, App.Eros.Config.itemlists.categoryItemSiblingsLimit);
			}
			return [];
		},

		...mapState({
			categoryItemSiblings: (state) => state.CategoryItemSiblings.categoryItemSiblings,
			showNetPrices: (state) => state.basket.showNetPrices
		})
	}
};
</script>